import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../Theme';

const useCommonStyles = makeStyles((theme) => {
	return {
		paper: {
			display: 'flex',
			flexDirection: 'column',
		},
		title: {
			color: `${COLORS.WATER_BLUE}`,
			alignItems: 'left',
			textAlign: 'center',
			...theme.typography.h6,
			fontWeight: 600,
			lineHeight: 1.6,
			[theme.breakpoints.up('sm')]: {
				...theme.typography.h1,
				color: `${COLORS.WATER_BLUE}`,
				fontWeight: 600,
				lineHeight: 1.6,
			},
			[theme.breakpoints.up('md')]: {
				...theme.typography.h1,
				color: `${COLORS.WATER_BLUE}`,
				fontWeight: 600,
				lineHeight: 1.6,
				textAlign: 'center',
			},
		},
		titleLeft: {
			color: `${COLORS.WATER_BLUE}`,
			alignItems: 'left',
			textAlign: 'left',
			...theme.typography.h6,
			fontWeight: 600,
			lineHeight: 1.6,
			[theme.breakpoints.up('sm')]: {
				...theme.typography.h1,
				color: `${COLORS.WATER_BLUE}`,
				fontWeight: 600,
				lineHeight: 1.6,
			},
			[theme.breakpoints.up('md')]: {
				...theme.typography.h1,
				color: `${COLORS.WATER_BLUE}`,
				fontWeight: 600,
				lineHeight: 1.6,
				textAlign: 'center',
			},
		},
		desc: {
			...theme.typography.h1,
			fontFamily: 'NanumR',
			[theme.breakpoints.up('md')]: {
				...theme.typography.h4,
			},
		},
		form: {
			// width: "80%", // Fix IE 11 issue.
			marginTop: theme.spacing(1),
		},
		inputLabel: {
			...theme.typography.subtitle1,
			color: `${COLORS.BROWNISH_GREY}`,
			fontFamily: 'NanumB',
			fontWeight: 'normal',
			lineHeight: '1',
			[theme.breakpoints.up('md')]: {
				...theme.typography.body1,
			},
		},
		inputProps: {
			...theme.typography.subtitle2,
			color: `${COLORS.BROWNISH_GREY}`,
			// [theme.breakpoints.up("md")]: {
			//   ...theme.typography.h1,
			//   },
		},
		passwordInputProps: {
			fontFamily: 'initial',
			fontSize: '16px',
			fontWeight: 'bold',
			color: `${COLORS.CHARCOAL_GREY}`,
		},
	};
});

export default useCommonStyles;
